// Block Counting Questions for AFOQT
// Auto-generated from block counting renders
// Combined from 27 data files (A-[)
// Sequential IDs: 1-302
import { IMAGE_PATH } from '../config';

export const blockCountingData = [
  {
    "id": 1,
    "image": `${IMAGE_PATH}/blocks/block_1_A.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      5,
      6,
      11
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.009",
      "total_blocks": 12,
      "touching_block_names": [
        "Cube.006",
        "Cube.007",
        "Cube.011"
      ]
    }
  },
  {
    "id": 2,
    "image": `${IMAGE_PATH}/blocks/block_2_A.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      6
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 12,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.007",
        "Cube.008",
        "Cube.009"
      ]
    }
  },
  {
    "id": 3,
    "image": `${IMAGE_PATH}/blocks/block_3_A.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      7,
      8,
      9,
      11
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 8 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 12,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.005",
        "Cube.006",
        "Cube.007",
        "Cube.008",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 4,
    "image": `${IMAGE_PATH}/blocks/block_4_A.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      2,
      4,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 12,
      "touching_block_names": [
        "Cube.002",
        "Cube.008"
      ]
    }
  },
  {
    "id": 5,
    "image": `${IMAGE_PATH}/blocks/block_5_A.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      5,
      6,
      7,
      8
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 6 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 12,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.006",
        "Cube.007",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 6,
    "image": `${IMAGE_PATH}/blocks/block_6_A.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      9,
      11
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 12,
      "touching_block_names": [
        "Cube",
        "Cube.002",
        "Cube.004"
      ]
    }
  },
  {
    "id": 7,
    "image": `${IMAGE_PATH}/blocks/block_7_A.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      1,
      2,
      10
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 12,
      "touching_block_names": [
        "Cube.001",
        "Cube.005"
      ]
    }
  },
  {
    "id": 8,
    "image": `${IMAGE_PATH}/blocks/block_8_A.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      11
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.010",
      "total_blocks": 12,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.008"
      ]
    }
  },
  {
    "id": 9,
    "image": `${IMAGE_PATH}/blocks/block_9_A.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      5,
      6,
      7,
      11
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 6 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 12,
      "touching_block_names": [
        "Cube.003",
        "Cube.004",
        "Cube.006",
        "Cube.007",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 10,
    "image": `${IMAGE_PATH}/blocks/block_10_A.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      5,
      6,
      8
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 6 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 12,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.006",
        "Cube.008",
        "Cube.009",
        "Cube.011"
      ]
    }
  },
  {
    "id": 11,
    "image": `${IMAGE_PATH}/blocks/block_11_A.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      2,
      3,
      6
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 12,
      "touching_block_names": [
        "Cube.001",
        "Cube.003",
        "Cube.004"
      ]
    }
  },
  {
    "id": 12,
    "image": `${IMAGE_PATH}/blocks/block_12_A.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      6
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.011",
      "total_blocks": 12,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.007",
        "Cube.008",
        "Cube.009"
      ]
    }
  },
  {
    "id": 13,
    "image": `${IMAGE_PATH}/blocks/block_1_A1.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      6,
      8,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 6 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.011",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.004",
        "Cube.006",
        "Cube.007",
        "Cube.008",
        "Cube.009",
        "Cube.010"
      ]
    }
  },
  {
    "id": 14,
    "image": `${IMAGE_PATH}/blocks/block_2_A1.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      1,
      2,
      9
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.002",
        "Cube.004"
      ]
    }
  },
  {
    "id": 15,
    "image": `${IMAGE_PATH}/blocks/block_3_A1.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      5,
      6,
      7,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 6 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.010",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.004",
        "Cube.006",
        "Cube.007",
        "Cube.008",
        "Cube.009",
        "Cube.011"
      ]
    }
  },
  {
    "id": 16,
    "image": `${IMAGE_PATH}/blocks/block_4_A1.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      5,
      6,
      9
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 6 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.002",
        "Cube.006",
        "Cube.010",
        "Cube.011",
        "Cube.012"
      ]
    }
  },
  {
    "id": 17,
    "image": `${IMAGE_PATH}/blocks/block_5_A1.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.009"
      ]
    }
  },
  {
    "id": 18,
    "image": `${IMAGE_PATH}/blocks/block_6_A1.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      2,
      3,
      5
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.006",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 19,
    "image": `${IMAGE_PATH}/blocks/block_7_A1.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      5,
      7,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.004",
        "Cube.007",
        "Cube.010",
        "Cube.011",
        "Cube.012"
      ]
    }
  },
  {
    "id": 20,
    "image": `${IMAGE_PATH}/blocks/block_8_A1.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      6
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.009",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.002",
        "Cube.008",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 21,
    "image": `${IMAGE_PATH}/blocks/block_9_A1.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      5,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.009",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 22,
    "image": `${IMAGE_PATH}/blocks/block_10_A1.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      5,
      8
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.004",
        "Cube.006"
      ]
    }
  },
  {
    "id": 23,
    "image": `${IMAGE_PATH}/blocks/block_1_B.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      6,
      9,
      12
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.009",
        "Cube.011"
      ]
    }
  },
  {
    "id": 24,
    "image": `${IMAGE_PATH}/blocks/block_2_B.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      2,
      3,
      4
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001",
        "Cube.005"
      ]
    }
  },
  {
    "id": 25,
    "image": `${IMAGE_PATH}/blocks/block_3_B.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.002",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 26,
    "image": `${IMAGE_PATH}/blocks/block_4_B.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      2,
      6,
      11
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.003",
        "Cube.004"
      ]
    }
  },
  {
    "id": 27,
    "image": `${IMAGE_PATH}/blocks/block_5_B.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      6,
      12
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001",
        "Cube.003",
        "Cube.004"
      ]
    }
  },
  {
    "id": 28,
    "image": `${IMAGE_PATH}/blocks/block_6_B.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      6,
      10,
      12
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.002",
        "Cube.004"
      ]
    }
  },
  {
    "id": 29,
    "image": `${IMAGE_PATH}/blocks/block_7_B.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      9,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.011",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.007",
        "Cube.010"
      ]
    }
  },
  {
    "id": 30,
    "image": `${IMAGE_PATH}/blocks/block_8_B.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      3,
      4,
      6
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.010",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.011"
      ]
    }
  },
  {
    "id": 31,
    "image": `${IMAGE_PATH}/blocks/block_9_B.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      5,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.009"
      ]
    }
  },
  {
    "id": 32,
    "image": `${IMAGE_PATH}/blocks/block_10_B.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      6
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.009",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.006",
        "Cube.007"
      ]
    }
  },
  {
    "id": 33,
    "image": `${IMAGE_PATH}/blocks/block_11_B.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      5,
      6,
      7,
      12
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 7 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.006",
        "Cube.007",
        "Cube.009",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 34,
    "image": `${IMAGE_PATH}/blocks/block_12_B.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      1,
      6,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 1 other block. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.003"
      ]
    }
  },
  {
    "id": 35,
    "image": `${IMAGE_PATH}/blocks/block_1_C.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      6,
      10,
      12
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.002",
        "Cube.004"
      ]
    }
  },
  {
    "id": 36,
    "image": `${IMAGE_PATH}/blocks/block_2_C.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      5
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.009",
        "Cube.011"
      ]
    }
  },
  {
    "id": 37,
    "image": `${IMAGE_PATH}/blocks/block_3_C.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      3,
      4,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001",
        "Cube.003",
        "Cube.004"
      ]
    }
  },
  {
    "id": 38,
    "image": `${IMAGE_PATH}/blocks/block_4_C.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      1,
      6,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 1 other block. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.003"
      ]
    }
  },
  {
    "id": 39,
    "image": `${IMAGE_PATH}/blocks/block_5_C.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      5,
      6,
      10
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.002",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 40,
    "image": `${IMAGE_PATH}/blocks/block_6_C.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      9
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.011",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.007",
        "Cube.010"
      ]
    }
  },
  {
    "id": 41,
    "image": `${IMAGE_PATH}/blocks/block_7_C.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      6,
      7,
      8,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 7 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.006",
        "Cube.007",
        "Cube.009",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 42,
    "image": `${IMAGE_PATH}/blocks/block_8_C.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      2,
      6,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001",
        "Cube.005"
      ]
    }
  },
  {
    "id": 43,
    "image": `${IMAGE_PATH}/blocks/block_9_C.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      6,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.009",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.006",
        "Cube.007"
      ]
    }
  },
  {
    "id": 44,
    "image": `${IMAGE_PATH}/blocks/block_10_C.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      7,
      9,
      11
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 9 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.005",
        "Cube.006",
        "Cube.007",
        "Cube.008",
        "Cube.009",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 45,
    "image": `${IMAGE_PATH}/blocks/block_11_C.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      11
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.003",
        "Cube.004"
      ]
    }
  },
  {
    "id": 46,
    "image": `${IMAGE_PATH}/blocks/block_12_C.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      10
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.010",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.011"
      ]
    }
  },
  {
    "id": 47,
    "image": `${IMAGE_PATH}/blocks/block_1_D.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      6,
      10,
      12
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.002",
        "Cube.004"
      ]
    }
  },
  {
    "id": 48,
    "image": `${IMAGE_PATH}/blocks/block_2_D.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      5,
      6,
      10
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.010",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.011"
      ]
    }
  },
  {
    "id": 49,
    "image": `${IMAGE_PATH}/blocks/block_3_D.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      6,
      11,
      12
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001",
        "Cube.005"
      ]
    }
  },
  {
    "id": 50,
    "image": `${IMAGE_PATH}/blocks/block_4_D.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      5,
      6,
      7,
      8
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 7 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.006",
        "Cube.007",
        "Cube.009",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 51,
    "image": `${IMAGE_PATH}/blocks/block_5_D.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      5,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.009",
        "Cube.011"
      ]
    }
  },
  {
    "id": 52,
    "image": `${IMAGE_PATH}/blocks/block_6_D.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      5
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.009"
      ]
    }
  },
  {
    "id": 53,
    "image": `${IMAGE_PATH}/blocks/block_7_D.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.009",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.006",
        "Cube.007"
      ]
    }
  },
  {
    "id": 54,
    "image": `${IMAGE_PATH}/blocks/block_8_D.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.011",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.007",
        "Cube.010"
      ]
    }
  },
  {
    "id": 55,
    "image": `${IMAGE_PATH}/blocks/block_9_D.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      3,
      4,
      6
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.002",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 56,
    "image": `${IMAGE_PATH}/blocks/block_10_D.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      6,
      9,
      10,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 9 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.005",
        "Cube.006",
        "Cube.007",
        "Cube.008",
        "Cube.009",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 57,
    "image": `${IMAGE_PATH}/blocks/block_11_D.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      1,
      3,
      6
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 1 other block. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.003"
      ]
    }
  },
  {
    "id": 58,
    "image": `${IMAGE_PATH}/blocks/block_12_D.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      3,
      4,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001",
        "Cube.003",
        "Cube.004"
      ]
    }
  },
  {
    "id": 59,
    "image": `${IMAGE_PATH}/blocks/block_1_E.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      12
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.010",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.008",
        "Cube.011"
      ]
    }
  },
  {
    "id": 60,
    "image": `${IMAGE_PATH}/blocks/block_2_E.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      7,
      8,
      9,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 8 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.006",
        "Cube.007",
        "Cube.008",
        "Cube.009",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 61,
    "image": `${IMAGE_PATH}/blocks/block_3_E.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      5,
      7,
      8,
      12
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.011",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.007",
        "Cube.008",
        "Cube.010"
      ]
    }
  },
  {
    "id": 62,
    "image": `${IMAGE_PATH}/blocks/block_4_E.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      2,
      3,
      10
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001",
        "Cube.003",
        "Cube.004"
      ]
    }
  },
  {
    "id": 63,
    "image": `${IMAGE_PATH}/blocks/block_5_E.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      5,
      6,
      7,
      9
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 7 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.003",
        "Cube.004",
        "Cube.006",
        "Cube.007",
        "Cube.009",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 64,
    "image": `${IMAGE_PATH}/blocks/block_6_E.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      1,
      3,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 1 other block. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.005"
      ]
    }
  },
  {
    "id": 65,
    "image": `${IMAGE_PATH}/blocks/block_7_E.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      3,
      6,
      12
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 1 other block. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001"
      ]
    }
  },
  {
    "id": 66,
    "image": `${IMAGE_PATH}/blocks/block_8_E.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      2,
      6,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.002",
        "Cube.008"
      ]
    }
  },
  {
    "id": 67,
    "image": `${IMAGE_PATH}/blocks/block_9_E.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      5,
      6,
      8
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.009",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.006",
        "Cube.007",
        "Cube.008"
      ]
    }
  },
  {
    "id": 68,
    "image": `${IMAGE_PATH}/blocks/block_10_E.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      6
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.008",
        "Cube.009",
        "Cube.011"
      ]
    }
  },
  {
    "id": 69,
    "image": `${IMAGE_PATH}/blocks/block_11_E.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      6,
      10,
      12
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.002",
        "Cube.004"
      ]
    }
  },
  {
    "id": 70,
    "image": `${IMAGE_PATH}/blocks/block_12_E.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      5,
      6
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.007",
        "Cube.009",
        "Cube.011",
        "Cube.012"
      ]
    }
  },
  {
    "id": 71,
    "image": `${IMAGE_PATH}/blocks/block_1_F.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      6,
      11
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001",
        "Cube.003"
      ]
    }
  },
  {
    "id": 72,
    "image": `${IMAGE_PATH}/blocks/block_2_F.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      3,
      5,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.010",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.008",
        "Cube.011"
      ]
    }
  },
  {
    "id": 73,
    "image": `${IMAGE_PATH}/blocks/block_3_F.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      5,
      6,
      8,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 6 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.006",
        "Cube.007",
        "Cube.009",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 74,
    "image": `${IMAGE_PATH}/blocks/block_4_F.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      5,
      7,
      8
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.008",
        "Cube.009",
        "Cube.011"
      ]
    }
  },
  {
    "id": 75,
    "image": `${IMAGE_PATH}/blocks/block_5_F.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      5,
      6,
      8
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.011",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.007",
        "Cube.008",
        "Cube.010"
      ]
    }
  },
  {
    "id": 76,
    "image": `${IMAGE_PATH}/blocks/block_6_F.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      12
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.004"
      ]
    }
  },
  {
    "id": 77,
    "image": `${IMAGE_PATH}/blocks/block_7_F.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      5,
      6,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.009",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.005",
        "Cube.006",
        "Cube.007",
        "Cube.008"
      ]
    }
  },
  {
    "id": 78,
    "image": `${IMAGE_PATH}/blocks/block_8_F.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      6,
      8,
      9,
      10
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 9 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.003",
        "Cube.006",
        "Cube.007",
        "Cube.008",
        "Cube.009",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 79,
    "image": `${IMAGE_PATH}/blocks/block_9_F.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      2,
      3,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001",
        "Cube.004"
      ]
    }
  },
  {
    "id": 80,
    "image": `${IMAGE_PATH}/blocks/block_10_F.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      6,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.008",
        "Cube.009"
      ]
    }
  },
  {
    "id": 81,
    "image": `${IMAGE_PATH}/blocks/block_11_F.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      2,
      6,
      12
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 1 other block. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.005"
      ]
    }
  },
  {
    "id": 82,
    "image": `${IMAGE_PATH}/blocks/block_12_F.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.007",
        "Cube.009",
        "Cube.011",
        "Cube.012"
      ]
    }
  },
  {
    "id": 83,
    "image": `${IMAGE_PATH}/blocks/block_1_G.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      1,
      2,
      4
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.004"
      ]
    }
  },
  {
    "id": 84,
    "image": `${IMAGE_PATH}/blocks/block_2_G.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      9,
      10,
      11,
      12
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 9 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.003",
        "Cube.006",
        "Cube.007",
        "Cube.008",
        "Cube.009",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 85,
    "image": `${IMAGE_PATH}/blocks/block_3_G.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      5,
      6,
      7
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 6 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.011",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.005",
        "Cube.007",
        "Cube.008",
        "Cube.010"
      ]
    }
  },
  {
    "id": 86,
    "image": `${IMAGE_PATH}/blocks/block_4_G.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      1,
      2,
      12
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.002",
        "Cube.004"
      ]
    }
  },
  {
    "id": 87,
    "image": `${IMAGE_PATH}/blocks/block_5_G.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      1,
      3,
      6
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 1 other block. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.005"
      ]
    }
  },
  {
    "id": 88,
    "image": `${IMAGE_PATH}/blocks/block_6_G.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      5,
      7,
      8,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 7 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.003",
        "Cube.005",
        "Cube.006",
        "Cube.007",
        "Cube.009",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 89,
    "image": `${IMAGE_PATH}/blocks/block_7_G.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      6,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.008",
        "Cube.009"
      ]
    }
  },
  {
    "id": 90,
    "image": `${IMAGE_PATH}/blocks/block_8_G.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      6,
      8,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 6 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.009",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.005",
        "Cube.006",
        "Cube.007",
        "Cube.008"
      ]
    }
  },
  {
    "id": 91,
    "image": `${IMAGE_PATH}/blocks/block_9_G.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      5,
      6,
      8
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 6 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.005",
        "Cube.008",
        "Cube.009",
        "Cube.011"
      ]
    }
  },
  {
    "id": 92,
    "image": `${IMAGE_PATH}/blocks/block_10_G.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.010",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.008",
        "Cube.011"
      ]
    }
  },
  {
    "id": 93,
    "image": `${IMAGE_PATH}/blocks/block_11_G.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      2,
      4,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001",
        "Cube.004"
      ]
    }
  },
  {
    "id": 94,
    "image": `${IMAGE_PATH}/blocks/block_12_G.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      5,
      6,
      8,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 6 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.006",
        "Cube.007",
        "Cube.009",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 95,
    "image": `${IMAGE_PATH}/blocks/block_1_H.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      5,
      6,
      7,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 6 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.011",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.005",
        "Cube.007",
        "Cube.008",
        "Cube.010"
      ]
    }
  },
  {
    "id": 96,
    "image": `${IMAGE_PATH}/blocks/block_2_H.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      6,
      11
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.004"
      ]
    }
  },
  {
    "id": 97,
    "image": `${IMAGE_PATH}/blocks/block_3_H.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      1,
      2,
      6
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 1 other block. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.005"
      ]
    }
  },
  {
    "id": 98,
    "image": `${IMAGE_PATH}/blocks/block_4_H.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      6
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.007",
        "Cube.009",
        "Cube.011",
        "Cube.012"
      ]
    }
  },
  {
    "id": 99,
    "image": `${IMAGE_PATH}/blocks/block_5_H.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      7,
      9,
      11
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 9 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.003",
        "Cube.006",
        "Cube.007",
        "Cube.008",
        "Cube.009",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 100,
    "image": `${IMAGE_PATH}/blocks/block_6_H.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      6,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.008",
        "Cube.009"
      ]
    }
  },
  {
    "id": 101,
    "image": `${IMAGE_PATH}/blocks/block_7_H.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      6
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001",
        "Cube.004"
      ]
    }
  },
  {
    "id": 102,
    "image": `${IMAGE_PATH}/blocks/block_8_H.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      6,
      8,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 6 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.005",
        "Cube.008",
        "Cube.009",
        "Cube.011"
      ]
    }
  },
  {
    "id": 103,
    "image": `${IMAGE_PATH}/blocks/block_9_H.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      5,
      6,
      7
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 6 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.009",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.005",
        "Cube.006",
        "Cube.007",
        "Cube.008"
      ]
    }
  },
  {
    "id": 104,
    "image": `${IMAGE_PATH}/blocks/block_10_H.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      6
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.010",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.008",
        "Cube.011"
      ]
    }
  },
  {
    "id": 105,
    "image": `${IMAGE_PATH}/blocks/block_11_H.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      5,
      6,
      7
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 6 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.006",
        "Cube.007",
        "Cube.009",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 106,
    "image": `${IMAGE_PATH}/blocks/block_12_H.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      5,
      6,
      7,
      12
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 7 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.003",
        "Cube.005",
        "Cube.006",
        "Cube.007",
        "Cube.009",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 107,
    "image": `${IMAGE_PATH}/blocks/block_1_I.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      6,
      7,
      9
    ],
    "correct": 3,
    "explanation": "The highlighted block is touching 9 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.003",
        "Cube.006",
        "Cube.007",
        "Cube.008",
        "Cube.009",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 108,
    "image": `${IMAGE_PATH}/blocks/block_2_I.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      2,
      4,
      6
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001",
        "Cube.004"
      ]
    }
  },
  {
    "id": 109,
    "image": `${IMAGE_PATH}/blocks/block_3_I.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      5,
      6,
      12
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 6 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.009",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.005",
        "Cube.006",
        "Cube.007",
        "Cube.008"
      ]
    }
  },
  {
    "id": 110,
    "image": `${IMAGE_PATH}/blocks/block_4_I.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      6,
      7,
      8,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 7 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.003",
        "Cube.005",
        "Cube.006",
        "Cube.007",
        "Cube.009",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 111,
    "image": `${IMAGE_PATH}/blocks/block_5_I.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      5,
      7,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.007",
        "Cube.009",
        "Cube.011",
        "Cube.012"
      ]
    }
  },
  {
    "id": 112,
    "image": `${IMAGE_PATH}/blocks/block_6_I.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      6,
      8,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 6 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.006",
        "Cube.007",
        "Cube.009",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 113,
    "image": `${IMAGE_PATH}/blocks/block_7_I.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      5,
      6,
      7,
      8
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 6 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.005",
        "Cube.008",
        "Cube.009",
        "Cube.011"
      ]
    }
  },
  {
    "id": 114,
    "image": `${IMAGE_PATH}/blocks/block_8_I.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      2,
      4,
      11
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.002",
        "Cube.004"
      ]
    }
  },
  {
    "id": 115,
    "image": `${IMAGE_PATH}/blocks/block_9_I.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      6,
      7,
      8
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 6 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.011",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.005",
        "Cube.007",
        "Cube.008",
        "Cube.010"
      ]
    }
  },
  {
    "id": 116,
    "image": `${IMAGE_PATH}/blocks/block_10_I.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      5
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.008",
        "Cube.009"
      ]
    }
  },
  {
    "id": 117,
    "image": `${IMAGE_PATH}/blocks/block_11_I.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      2,
      11,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.004"
      ]
    }
  },
  {
    "id": 118,
    "image": `${IMAGE_PATH}/blocks/block_12_I.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      1,
      2,
      3
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 1 other block. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.005"
      ]
    }
  },
  {
    "id": 119,
    "image": `${IMAGE_PATH}/blocks/block_1_J.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.006",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 120,
    "image": `${IMAGE_PATH}/blocks/block_2_J.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      7,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.005",
        "Cube.008"
      ]
    }
  },
  {
    "id": 121,
    "image": `${IMAGE_PATH}/blocks/block_3_J.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      6
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.005",
        "Cube.006",
        "Cube.012"
      ]
    }
  },
  {
    "id": 122,
    "image": `${IMAGE_PATH}/blocks/block_4_J.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      5,
      7,
      9
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.002",
        "Cube.004",
        "Cube.007"
      ]
    }
  },
  {
    "id": 123,
    "image": `${IMAGE_PATH}/blocks/block_5_J.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      5,
      7,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.003",
        "Cube.005",
        "Cube.006",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 124,
    "image": `${IMAGE_PATH}/blocks/block_6_J.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      3,
      4,
      7
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.007"
      ]
    }
  },
  {
    "id": 125,
    "image": `${IMAGE_PATH}/blocks/block_7_J.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      9
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.005",
        "Cube.008"
      ]
    }
  },
  {
    "id": 126,
    "image": `${IMAGE_PATH}/blocks/block_8_J.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      6,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.003",
        "Cube.004"
      ]
    }
  },
  {
    "id": 127,
    "image": `${IMAGE_PATH}/blocks/block_9_J.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      3,
      4,
      5
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.001",
        "Cube.004",
        "Cube.007"
      ]
    }
  },
  {
    "id": 128,
    "image": `${IMAGE_PATH}/blocks/block_10_J.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      5,
      6,
      7
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.003",
        "Cube.006",
        "Cube.007"
      ]
    }
  },
  {
    "id": 129,
    "image": `${IMAGE_PATH}/blocks/block_1_K.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      2,
      5,
      8
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.003",
        "Cube.012"
      ]
    }
  },
  {
    "id": 130,
    "image": `${IMAGE_PATH}/blocks/block_2_K.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      6,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.005",
        "Cube.008"
      ]
    }
  },
  {
    "id": 131,
    "image": `${IMAGE_PATH}/blocks/block_3_K.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      9
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.005",
        "Cube.006",
        "Cube.012"
      ]
    }
  },
  {
    "id": 132,
    "image": `${IMAGE_PATH}/blocks/block_4_K.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      6
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.002",
        "Cube.004",
        "Cube.007"
      ]
    }
  },
  {
    "id": 133,
    "image": `${IMAGE_PATH}/blocks/block_5_K.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      1,
      2,
      3
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.003",
        "Cube.004"
      ]
    }
  },
  {
    "id": 134,
    "image": `${IMAGE_PATH}/blocks/block_6_K.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      2,
      3,
      4
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.003",
        "Cube.004"
      ]
    }
  },
  {
    "id": 135,
    "image": `${IMAGE_PATH}/blocks/block_7_K.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      5,
      6,
      9
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.005",
        "Cube.008"
      ]
    }
  },
  {
    "id": 136,
    "image": `${IMAGE_PATH}/blocks/block_8_K.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      5,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.006",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 137,
    "image": `${IMAGE_PATH}/blocks/block_9_K.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      5,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.002",
        "Cube.003",
        "Cube.006",
        "Cube.007"
      ]
    }
  },
  {
    "id": 138,
    "image": `${IMAGE_PATH}/blocks/block_10_K.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      6
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.003",
        "Cube.005",
        "Cube.006",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 139,
    "image": `${IMAGE_PATH}/blocks/block_1_L.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      6
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.005",
        "Cube.008"
      ]
    }
  },
  {
    "id": 140,
    "image": `${IMAGE_PATH}/blocks/block_2_L.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      2,
      4,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.003",
        "Cube.004"
      ]
    }
  },
  {
    "id": 141,
    "image": `${IMAGE_PATH}/blocks/block_3_L.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      5,
      6,
      7
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.002",
        "Cube.004",
        "Cube.007"
      ]
    }
  },
  {
    "id": 142,
    "image": `${IMAGE_PATH}/blocks/block_4_L.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.005",
        "Cube.008"
      ]
    }
  },
  {
    "id": 143,
    "image": `${IMAGE_PATH}/blocks/block_5_L.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      6,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.006",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 144,
    "image": `${IMAGE_PATH}/blocks/block_6_L.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      9
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.003",
        "Cube.005",
        "Cube.006",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 145,
    "image": `${IMAGE_PATH}/blocks/block_7_L.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      3,
      4,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.002",
        "Cube.003",
        "Cube.006"
      ]
    }
  },
  {
    "id": 146,
    "image": `${IMAGE_PATH}/blocks/block_8_L.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      2,
      3,
      4
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.001",
        "Cube.003"
      ]
    }
  },
  {
    "id": 147,
    "image": `${IMAGE_PATH}/blocks/block_9_L.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      5,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.005",
        "Cube.006",
        "Cube.012"
      ]
    }
  },
  {
    "id": 148,
    "image": `${IMAGE_PATH}/blocks/block_10_L.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      5
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.003",
        "Cube.007",
        "Cube.012"
      ]
    }
  },
  {
    "id": 149,
    "image": `${IMAGE_PATH}/blocks/block_1_M.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      3,
      5,
      7
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.006",
        "Cube.012"
      ]
    }
  },
  {
    "id": 150,
    "image": `${IMAGE_PATH}/blocks/block_2_M.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      7,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.006",
        "Cube.012"
      ]
    }
  },
  {
    "id": 151,
    "image": `${IMAGE_PATH}/blocks/block_3_M.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      5,
      6,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.003",
        "Cube.005",
        "Cube.006",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 152,
    "image": `${IMAGE_PATH}/blocks/block_4_M.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      5
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.005",
        "Cube.008"
      ]
    }
  },
  {
    "id": 153,
    "image": `${IMAGE_PATH}/blocks/block_5_M.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      2,
      3,
      5
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.001",
        "Cube.003"
      ]
    }
  },
  {
    "id": 154,
    "image": `${IMAGE_PATH}/blocks/block_6_M.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      5,
      7,
      9
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.003",
        "Cube.007",
        "Cube.012"
      ]
    }
  },
  {
    "id": 155,
    "image": `${IMAGE_PATH}/blocks/block_7_M.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      9
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.003",
        "Cube.006"
      ]
    }
  },
  {
    "id": 156,
    "image": `${IMAGE_PATH}/blocks/block_8_M.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      2,
      5,
      9
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 1 other block. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.003"
      ]
    }
  },
  {
    "id": 157,
    "image": `${IMAGE_PATH}/blocks/block_9_M.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      9
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.002",
        "Cube.004",
        "Cube.007"
      ]
    }
  },
  {
    "id": 158,
    "image": `${IMAGE_PATH}/blocks/block_10_M.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      6
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.005",
        "Cube.008"
      ]
    }
  },
  {
    "id": 159,
    "image": `${IMAGE_PATH}/blocks/block_1_N.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.004",
        "Cube.007"
      ]
    }
  },
  {
    "id": 160,
    "image": `${IMAGE_PATH}/blocks/block_2_N.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      5,
      7,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.005",
        "Cube.007",
        "Cube.008"
      ]
    }
  },
  {
    "id": 161,
    "image": `${IMAGE_PATH}/blocks/block_3_N.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      6
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.002",
        "Cube.006",
        "Cube.012"
      ]
    }
  },
  {
    "id": 162,
    "image": `${IMAGE_PATH}/blocks/block_4_N.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      2,
      4,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.003",
        "Cube.012"
      ]
    }
  },
  {
    "id": 163,
    "image": `${IMAGE_PATH}/blocks/block_5_N.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      3,
      7,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.003",
        "Cube.006",
        "Cube.007"
      ]
    }
  },
  {
    "id": 164,
    "image": `${IMAGE_PATH}/blocks/block_6_N.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      3,
      7,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.003",
        "Cube.004",
        "Cube.006"
      ]
    }
  },
  {
    "id": 165,
    "image": `${IMAGE_PATH}/blocks/block_7_N.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      6
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.003",
        "Cube.005",
        "Cube.006",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 166,
    "image": `${IMAGE_PATH}/blocks/block_8_N.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      5,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.002",
        "Cube.006",
        "Cube.012"
      ]
    }
  },
  {
    "id": 167,
    "image": `${IMAGE_PATH}/blocks/block_9_N.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      1,
      2,
      9
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.005",
        "Cube.008"
      ]
    }
  },
  {
    "id": 168,
    "image": `${IMAGE_PATH}/blocks/block_10_N.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.005",
        "Cube.008"
      ]
    }
  },
  {
    "id": 169,
    "image": `${IMAGE_PATH}/blocks/block_1_O.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.001",
        "Cube.005",
        "Cube.007",
        "Cube.008"
      ]
    }
  },
  {
    "id": 170,
    "image": `${IMAGE_PATH}/blocks/block_2_O.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      7,
      9
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.001",
        "Cube.003",
        "Cube.004"
      ]
    }
  },
  {
    "id": 171,
    "image": `${IMAGE_PATH}/blocks/block_3_O.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      6
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.005",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 172,
    "image": `${IMAGE_PATH}/blocks/block_4_O.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      2,
      3,
      9
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.002",
        "Cube.004",
        "Cube.012"
      ]
    }
  },
  {
    "id": 173,
    "image": `${IMAGE_PATH}/blocks/block_5_O.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.005",
        "Cube.006",
        "Cube.008"
      ]
    }
  },
  {
    "id": 174,
    "image": `${IMAGE_PATH}/blocks/block_6_O.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      5,
      6,
      7
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.003",
        "Cube.005",
        "Cube.012"
      ]
    }
  },
  {
    "id": 175,
    "image": `${IMAGE_PATH}/blocks/block_7_O.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.006",
        "Cube.007"
      ]
    }
  },
  {
    "id": 176,
    "image": `${IMAGE_PATH}/blocks/block_8_O.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      9
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.004",
        "Cube.006"
      ]
    }
  },
  {
    "id": 177,
    "image": `${IMAGE_PATH}/blocks/block_9_O.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      6,
      7,
      8
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 7 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.002",
        "Cube.003",
        "Cube.004",
        "Cube.005",
        "Cube.007",
        "Cube.008"
      ]
    }
  },
  {
    "id": 178,
    "image": `${IMAGE_PATH}/blocks/block_10_O.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      6
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.003",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 179,
    "image": `${IMAGE_PATH}/blocks/block_1_P.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      5,
      6,
      9
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.006",
        "Cube.007"
      ]
    }
  },
  {
    "id": 180,
    "image": `${IMAGE_PATH}/blocks/block_2_P.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      3,
      5,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.001",
        "Cube.005",
        "Cube.012"
      ]
    }
  },
  {
    "id": 181,
    "image": `${IMAGE_PATH}/blocks/block_3_P.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      3,
      4,
      5
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.001",
        "Cube.003",
        "Cube.004"
      ]
    }
  },
  {
    "id": 182,
    "image": `${IMAGE_PATH}/blocks/block_4_P.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.005",
        "Cube.012"
      ]
    }
  },
  {
    "id": 183,
    "image": `${IMAGE_PATH}/blocks/block_5_P.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      6,
      7,
      8
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 7 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.002",
        "Cube.003",
        "Cube.004",
        "Cube.005",
        "Cube.007",
        "Cube.008"
      ]
    }
  },
  {
    "id": 184,
    "image": `${IMAGE_PATH}/blocks/block_6_P.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.004",
        "Cube.006"
      ]
    }
  },
  {
    "id": 185,
    "image": `${IMAGE_PATH}/blocks/block_7_P.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      6
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.005",
        "Cube.006",
        "Cube.008"
      ]
    }
  },
  {
    "id": 186,
    "image": `${IMAGE_PATH}/blocks/block_8_P.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      3,
      7,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.002",
        "Cube.004",
        "Cube.012"
      ]
    }
  },
  {
    "id": 187,
    "image": `${IMAGE_PATH}/blocks/block_9_P.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      3,
      4,
      5
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube.001",
        "Cube.005",
        "Cube.007"
      ]
    }
  },
  {
    "id": 188,
    "image": `${IMAGE_PATH}/blocks/block_10_P.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      9
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 10,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.003",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 189,
    "image": `${IMAGE_PATH}/blocks/block_1_Q.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      5,
      8,
      10
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.009",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.004",
        "Cube.006",
        "Cube.007"
      ]
    }
  },
  {
    "id": 190,
    "image": `${IMAGE_PATH}/blocks/block_2_Q.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      8,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.001",
        "Cube.005",
        "Cube.012"
      ]
    }
  },
  {
    "id": 191,
    "image": `${IMAGE_PATH}/blocks/block_3_Q.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      5,
      7,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.003",
        "Cube.005",
        "Cube.006",
        "Cube.008"
      ]
    }
  },
  {
    "id": 192,
    "image": `${IMAGE_PATH}/blocks/block_4_Q.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      6
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.003",
        "Cube.005",
        "Cube.012"
      ]
    }
  },
  {
    "id": 193,
    "image": `${IMAGE_PATH}/blocks/block_5_Q.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      7,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.004",
        "Cube.006"
      ]
    }
  },
  {
    "id": 194,
    "image": `${IMAGE_PATH}/blocks/block_6_Q.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      5,
      8,
      10
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.001",
        "Cube.004",
        "Cube.009"
      ]
    }
  },
  {
    "id": 195,
    "image": `${IMAGE_PATH}/blocks/block_7_Q.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      5,
      7,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.006",
        "Cube.007",
        "Cube.009"
      ]
    }
  },
  {
    "id": 196,
    "image": `${IMAGE_PATH}/blocks/block_8_Q.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      7,
      8,
      9,
      10
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 7 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.002",
        "Cube.003",
        "Cube.004",
        "Cube.005",
        "Cube.007",
        "Cube.008"
      ]
    }
  },
  {
    "id": 197,
    "image": `${IMAGE_PATH}/blocks/block_9_Q.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      5,
      7
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.005",
        "Cube.012"
      ]
    }
  },
  {
    "id": 198,
    "image": `${IMAGE_PATH}/blocks/block_10_Q.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.002",
        "Cube.004",
        "Cube.009",
        "Cube.012"
      ]
    }
  },
  {
    "id": 199,
    "image": `${IMAGE_PATH}/blocks/block_11_Q.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      6
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.003",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 200,
    "image": `${IMAGE_PATH}/blocks/block_1_R.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      8,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.001",
        "Cube.004",
        "Cube.009"
      ]
    }
  },
  {
    "id": 201,
    "image": `${IMAGE_PATH}/blocks/block_2_R.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      8,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.009",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.004",
        "Cube.006",
        "Cube.007"
      ]
    }
  },
  {
    "id": 202,
    "image": `${IMAGE_PATH}/blocks/block_3_R.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      7
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.005",
        "Cube.012"
      ]
    }
  },
  {
    "id": 203,
    "image": `${IMAGE_PATH}/blocks/block_4_R.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      5,
      6,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.006",
        "Cube.007",
        "Cube.009"
      ]
    }
  },
  {
    "id": 204,
    "image": `${IMAGE_PATH}/blocks/block_5_R.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      5,
      7
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.005",
        "Cube.012"
      ]
    }
  },
  {
    "id": 205,
    "image": `${IMAGE_PATH}/blocks/block_6_R.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      7,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.002",
        "Cube.004",
        "Cube.009",
        "Cube.012"
      ]
    }
  },
  {
    "id": 206,
    "image": `${IMAGE_PATH}/blocks/block_7_R.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      10
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.003",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 207,
    "image": `${IMAGE_PATH}/blocks/block_8_R.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      6,
      7,
      8,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 7 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.002",
        "Cube.003",
        "Cube.004",
        "Cube.005",
        "Cube.007",
        "Cube.008"
      ]
    }
  },
  {
    "id": 208,
    "image": `${IMAGE_PATH}/blocks/block_9_R.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      5,
      6
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.004",
        "Cube.006"
      ]
    }
  },
  {
    "id": 209,
    "image": `${IMAGE_PATH}/blocks/block_10_R.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      5,
      6,
      7
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.003",
        "Cube.005",
        "Cube.006",
        "Cube.008"
      ]
    }
  },
  {
    "id": 210,
    "image": `${IMAGE_PATH}/blocks/block_11_R.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      5,
      6,
      7,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 6 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.003",
        "Cube.005",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 211,
    "image": `${IMAGE_PATH}/blocks/block_1_S.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.002",
        "Cube.004",
        "Cube.009",
        "Cube.012"
      ]
    }
  },
  {
    "id": 212,
    "image": `${IMAGE_PATH}/blocks/block_2_S.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      2,
      3,
      4
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.003",
        "Cube.008"
      ]
    }
  },
  {
    "id": 213,
    "image": `${IMAGE_PATH}/blocks/block_3_S.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      5,
      7
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.003",
        "Cube.006",
        "Cube.008"
      ]
    }
  },
  {
    "id": 214,
    "image": `${IMAGE_PATH}/blocks/block_4_S.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      5,
      6
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.006",
        "Cube.009"
      ]
    }
  },
  {
    "id": 215,
    "image": `${IMAGE_PATH}/blocks/block_5_S.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      5,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.004",
        "Cube.006"
      ]
    }
  },
  {
    "id": 216,
    "image": `${IMAGE_PATH}/blocks/block_6_S.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      6
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.003",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 217,
    "image": `${IMAGE_PATH}/blocks/block_7_S.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      6
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.005",
        "Cube.007",
        "Cube.012"
      ]
    }
  },
  {
    "id": 218,
    "image": `${IMAGE_PATH}/blocks/block_8_S.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      5,
      7,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.005",
        "Cube.007",
        "Cube.012"
      ]
    }
  },
  {
    "id": 219,
    "image": `${IMAGE_PATH}/blocks/block_9_S.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      5
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.001",
        "Cube.003",
        "Cube.008"
      ]
    }
  },
  {
    "id": 220,
    "image": `${IMAGE_PATH}/blocks/block_10_S.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      2,
      5,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.009",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.004",
        "Cube.006"
      ]
    }
  },
  {
    "id": 221,
    "image": `${IMAGE_PATH}/blocks/block_11_S.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      5,
      6,
      7,
      8
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 6 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.002",
        "Cube.003",
        "Cube.004",
        "Cube.007",
        "Cube.008"
      ]
    }
  },
  {
    "id": 222,
    "image": `${IMAGE_PATH}/blocks/block_1_T.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      8
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.002",
        "Cube.006",
        "Cube.009"
      ]
    }
  },
  {
    "id": 223,
    "image": `${IMAGE_PATH}/blocks/block_2_T.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      5,
      6,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.003",
        "Cube.005",
        "Cube.006",
        "Cube.008"
      ]
    }
  },
  {
    "id": 224,
    "image": `${IMAGE_PATH}/blocks/block_3_T.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      5,
      6,
      7
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.005",
        "Cube.007",
        "Cube.012"
      ]
    }
  },
  {
    "id": 225,
    "image": `${IMAGE_PATH}/blocks/block_4_T.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      5
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.001",
        "Cube.003",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 226,
    "image": `${IMAGE_PATH}/blocks/block_5_T.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      10
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.003",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 227,
    "image": `${IMAGE_PATH}/blocks/block_6_T.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      5,
      7,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.005",
        "Cube.007",
        "Cube.012"
      ]
    }
  },
  {
    "id": 228,
    "image": `${IMAGE_PATH}/blocks/block_7_T.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      3,
      4,
      8
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.006"
      ]
    }
  },
  {
    "id": 229,
    "image": `${IMAGE_PATH}/blocks/block_8_T.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.003",
        "Cube.005",
        "Cube.008"
      ]
    }
  },
  {
    "id": 230,
    "image": `${IMAGE_PATH}/blocks/block_9_T.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      5,
      7
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.002",
        "Cube.004",
        "Cube.009",
        "Cube.012"
      ]
    }
  },
  {
    "id": 231,
    "image": `${IMAGE_PATH}/blocks/block_10_T.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      2,
      3,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.003",
        "Cube.008"
      ]
    }
  },
  {
    "id": 232,
    "image": `${IMAGE_PATH}/blocks/block_11_T.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      5,
      9
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.009",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.004",
        "Cube.006"
      ]
    }
  },
  {
    "id": 233,
    "image": `${IMAGE_PATH}/blocks/block_1_U.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      5,
      7,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.005",
        "Cube.007",
        "Cube.012"
      ]
    }
  },
  {
    "id": 234,
    "image": `${IMAGE_PATH}/blocks/block_2_U.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      8,
      10
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.002",
        "Cube.006",
        "Cube.009"
      ]
    }
  },
  {
    "id": 235,
    "image": `${IMAGE_PATH}/blocks/block_3_U.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      2,
      3,
      4
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.009",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.004",
        "Cube.006"
      ]
    }
  },
  {
    "id": 236,
    "image": `${IMAGE_PATH}/blocks/block_4_U.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      7
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.001",
        "Cube.003",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 237,
    "image": `${IMAGE_PATH}/blocks/block_5_U.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      8,
      10
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.006"
      ]
    }
  },
  {
    "id": 238,
    "image": `${IMAGE_PATH}/blocks/block_6_U.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      5,
      6,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.003",
        "Cube.005",
        "Cube.006",
        "Cube.008"
      ]
    }
  },
  {
    "id": 239,
    "image": `${IMAGE_PATH}/blocks/block_7_U.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      6
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.005",
        "Cube.007",
        "Cube.012"
      ]
    }
  },
  {
    "id": 240,
    "image": `${IMAGE_PATH}/blocks/block_8_U.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      6,
      7,
      10
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.003",
        "Cube.005",
        "Cube.008"
      ]
    }
  },
  {
    "id": 241,
    "image": `${IMAGE_PATH}/blocks/block_9_U.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      2,
      3,
      5
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.003",
        "Cube.008"
      ]
    }
  },
  {
    "id": 242,
    "image": `${IMAGE_PATH}/blocks/block_10_U.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      5,
      6,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.003",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 243,
    "image": `${IMAGE_PATH}/blocks/block_11_U.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      7
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.002",
        "Cube.004",
        "Cube.009",
        "Cube.012"
      ]
    }
  },
  {
    "id": 244,
    "image": `${IMAGE_PATH}/blocks/block_1_V.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      6,
      7
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.002",
        "Cube.003",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 245,
    "image": `${IMAGE_PATH}/blocks/block_2_V.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      10
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.007",
        "Cube.012"
      ]
    }
  },
  {
    "id": 246,
    "image": `${IMAGE_PATH}/blocks/block_3_V.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      2,
      3,
      10
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.006"
      ]
    }
  },
  {
    "id": 247,
    "image": `${IMAGE_PATH}/blocks/block_4_V.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      5
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.007",
        "Cube.012"
      ]
    }
  },
  {
    "id": 248,
    "image": `${IMAGE_PATH}/blocks/block_5_V.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      2,
      3,
      4
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.004",
        "Cube.005"
      ]
    }
  },
  {
    "id": 249,
    "image": `${IMAGE_PATH}/blocks/block_6_V.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      2,
      4,
      5
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.003",
        "Cube.008"
      ]
    }
  },
  {
    "id": 250,
    "image": `${IMAGE_PATH}/blocks/block_7_V.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      5,
      6,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.002",
        "Cube.004",
        "Cube.005",
        "Cube.009",
        "Cube.012"
      ]
    }
  },
  {
    "id": 251,
    "image": `${IMAGE_PATH}/blocks/block_8_V.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      10
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.006",
        "Cube.009"
      ]
    }
  },
  {
    "id": 252,
    "image": `${IMAGE_PATH}/blocks/block_9_V.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      5,
      10
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.001",
        "Cube.006"
      ]
    }
  },
  {
    "id": 253,
    "image": `${IMAGE_PATH}/blocks/block_10_V.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      1,
      2,
      3
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.009",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.004",
        "Cube.006"
      ]
    }
  },
  {
    "id": 254,
    "image": `${IMAGE_PATH}/blocks/block_11_V.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.003",
        "Cube.006",
        "Cube.008"
      ]
    }
  },
  {
    "id": 255,
    "image": `${IMAGE_PATH}/blocks/block_1_W.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      4,
      5,
      7,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.003",
        "Cube.004",
        "Cube.007",
        "Cube.012"
      ]
    }
  },
  {
    "id": 256,
    "image": `${IMAGE_PATH}/blocks/block_2_W.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      10
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.003",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 257,
    "image": `${IMAGE_PATH}/blocks/block_3_W.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      6
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.002",
        "Cube.003",
        "Cube.008"
      ]
    }
  },
  {
    "id": 258,
    "image": `${IMAGE_PATH}/blocks/block_4_W.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      6
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.002",
        "Cube.003",
        "Cube.004",
        "Cube.007",
        "Cube.008"
      ]
    }
  },
  {
    "id": 259,
    "image": `${IMAGE_PATH}/blocks/block_5_W.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      7
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.001",
        "Cube.005",
        "Cube.009",
        "Cube.012"
      ]
    }
  },
  {
    "id": 260,
    "image": `${IMAGE_PATH}/blocks/block_6_W.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      5,
      9,
      10
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.009",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.005",
        "Cube.006"
      ]
    }
  },
  {
    "id": 261,
    "image": `${IMAGE_PATH}/blocks/block_7_W.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      5,
      9
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.006",
        "Cube.009"
      ]
    }
  },
  {
    "id": 262,
    "image": `${IMAGE_PATH}/blocks/block_8_W.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      5
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.002",
        "Cube.004",
        "Cube.006"
      ]
    }
  },
  {
    "id": 263,
    "image": `${IMAGE_PATH}/blocks/block_9_W.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      5,
      6
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.003",
        "Cube.004",
        "Cube.006",
        "Cube.008"
      ]
    }
  },
  {
    "id": 264,
    "image": `${IMAGE_PATH}/blocks/block_10_W.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      3,
      4,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.007"
      ]
    }
  },
  {
    "id": 265,
    "image": `${IMAGE_PATH}/blocks/block_11_W.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      5,
      6,
      7
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.007",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 266,
    "image": `${IMAGE_PATH}/blocks/block_1_X.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      5,
      6
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.001",
        "Cube.005",
        "Cube.009",
        "Cube.012"
      ]
    }
  },
  {
    "id": 267,
    "image": `${IMAGE_PATH}/blocks/block_2_X.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      7
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.003",
        "Cube.004",
        "Cube.006",
        "Cube.008"
      ]
    }
  },
  {
    "id": 268,
    "image": `${IMAGE_PATH}/blocks/block_3_X.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      7
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.003",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 269,
    "image": `${IMAGE_PATH}/blocks/block_4_X.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      5,
      6,
      7
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.003",
        "Cube.004",
        "Cube.007",
        "Cube.012"
      ]
    }
  },
  {
    "id": 270,
    "image": `${IMAGE_PATH}/blocks/block_5_X.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      3,
      5,
      8
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.007"
      ]
    }
  },
  {
    "id": 271,
    "image": `${IMAGE_PATH}/blocks/block_6_X.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      7
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.004",
        "Cube.007",
        "Cube.008",
        "Cube.012"
      ]
    }
  },
  {
    "id": 272,
    "image": `${IMAGE_PATH}/blocks/block_7_X.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      1,
      2,
      3
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.009",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.005",
        "Cube.006"
      ]
    }
  },
  {
    "id": 273,
    "image": `${IMAGE_PATH}/blocks/block_8_X.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      10
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.002",
        "Cube.003",
        "Cube.004",
        "Cube.007",
        "Cube.008"
      ]
    }
  },
  {
    "id": 274,
    "image": `${IMAGE_PATH}/blocks/block_9_X.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      2,
      3,
      5
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.006",
        "Cube.009"
      ]
    }
  },
  {
    "id": 275,
    "image": `${IMAGE_PATH}/blocks/block_10_X.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      3,
      4,
      8
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube.002",
        "Cube.004",
        "Cube.006"
      ]
    }
  },
  {
    "id": 276,
    "image": `${IMAGE_PATH}/blocks/block_11_X.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      6,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 11,
      "touching_block_names": [
        "Cube",
        "Cube.002",
        "Cube.003",
        "Cube.008"
      ]
    }
  },
  {
    "id": 277,
    "image": `${IMAGE_PATH}/blocks/block_1_Y.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      2,
      4,
      6
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.004",
        "Cube.006"
      ]
    }
  },
  {
    "id": 278,
    "image": `${IMAGE_PATH}/blocks/block_2_Y.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      2,
      3,
      12
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 1 other block. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.008",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.009"
      ]
    }
  },
  {
    "id": 279,
    "image": `${IMAGE_PATH}/blocks/block_3_Y.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      5,
      10,
      12
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.009",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.003",
        "Cube.006",
        "Cube.008"
      ]
    }
  },
  {
    "id": 280,
    "image": `${IMAGE_PATH}/blocks/block_4_Y.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      6
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.002",
        "Cube.004",
        "Cube.005",
        "Cube.006"
      ]
    }
  },
  {
    "id": 281,
    "image": `${IMAGE_PATH}/blocks/block_5_Y.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      4,
      5,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.004",
        "Cube.006"
      ]
    }
  },
  {
    "id": 282,
    "image": `${IMAGE_PATH}/blocks/block_6_Y.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      9
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.002",
        "Cube.010",
        "Cube.011"
      ]
    }
  },
  {
    "id": 283,
    "image": `${IMAGE_PATH}/blocks/block_7_Y.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      1,
      2,
      3
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.010",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.007",
        "Cube.011"
      ]
    }
  },
  {
    "id": 284,
    "image": `${IMAGE_PATH}/blocks/block_8_Y.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      2,
      4,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.011",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.007",
        "Cube.010"
      ]
    }
  },
  {
    "id": 285,
    "image": `${IMAGE_PATH}/blocks/block_9_Y.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      5
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.005",
        "Cube.012"
      ]
    }
  },
  {
    "id": 286,
    "image": `${IMAGE_PATH}/blocks/block_10_Y.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      5,
      7
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.003",
        "Cube.005",
        "Cube.007"
      ]
    }
  },
  {
    "id": 287,
    "image": `${IMAGE_PATH}/blocks/block_11_Y.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      5,
      7,
      8
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001",
        "Cube.003",
        "Cube.005",
        "Cube.009",
        "Cube.012"
      ]
    }
  },
  {
    "id": 288,
    "image": `${IMAGE_PATH}/blocks/block_12_Y.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      6
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.002",
        "Cube.004",
        "Cube.007"
      ]
    }
  },
  {
    "id": 289,
    "image": `${IMAGE_PATH}/blocks/block_13_Y.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      6,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.003",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.002",
        "Cube.006",
        "Cube.009"
      ]
    }
  },
  {
    "id": 290,
    "image": `${IMAGE_PATH}/blocks/block_1_Z.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      9,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.005",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001",
        "Cube.002",
        "Cube.004",
        "Cube.006"
      ]
    }
  },
  {
    "id": 291,
    "image": `${IMAGE_PATH}/blocks/block_2_Z.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      2,
      3,
      11
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.011",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.007",
        "Cube.010"
      ]
    }
  },
  {
    "id": 292,
    "image": `${IMAGE_PATH}/blocks/block_3_Z.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      3,
      4,
      6
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.002",
        "Cube.003",
        "Cube.004"
      ]
    }
  },
  {
    "id": 293,
    "image": `${IMAGE_PATH}/blocks/block_4_Z.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      5,
      7,
      8
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 5 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.004",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.003",
        "Cube.005",
        "Cube.012"
      ]
    }
  },
  {
    "id": 294,
    "image": `${IMAGE_PATH}/blocks/block_5_Z.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      9,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.009",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.002",
        "Cube.003",
        "Cube.006",
        "Cube.008"
      ]
    }
  },
  {
    "id": 295,
    "image": `${IMAGE_PATH}/blocks/block_6_Z.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      9,
      12
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.001",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.002",
        "Cube.004",
        "Cube.005",
        "Cube.006"
      ]
    }
  },
  {
    "id": 296,
    "image": `${IMAGE_PATH}/blocks/block_7_Z.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      2,
      3,
      4,
      6
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 4 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.002",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube",
        "Cube.001",
        "Cube.005",
        "Cube.009"
      ]
    }
  },
  {
    "id": 297,
    "image": `${IMAGE_PATH}/blocks/block_8_Z.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      0,
      1,
      2,
      12
    ],
    "correct": 2,
    "explanation": "The highlighted block is touching 2 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.010",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.007",
        "Cube.011"
      ]
    }
  },
  {
    "id": 298,
    "image": `${IMAGE_PATH}/blocks/block_9_Z.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      1,
      3,
      6,
      10
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.012",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.003",
        "Cube.004",
        "Cube.006"
      ]
    }
  },
  {
    "id": 299,
    "image": `${IMAGE_PATH}/blocks/block_10_Z.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      5,
      6,
      7,
      8
    ],
    "correct": 1,
    "explanation": "The highlighted block is touching 6 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.006",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.001",
        "Cube.005",
        "Cube.007",
        "Cube.008",
        "Cube.009",
        "Cube.012"
      ]
    }
  },
  {
    "id": 300,
    "image": `${IMAGE_PATH}/blocks/block_11_Z.webp`,
    "question": "How many blocks are touching the highlighted block?",
    "options": [
      3,
      4,
      6,
      10
    ],
    "correct": 0,
    "explanation": "The highlighted block is touching 3 other blocks. Count each block that shares a face with the highlighted block.",
    "metadata": {
      "highlighted_block": "Cube.007",
      "total_blocks": 13,
      "touching_block_names": [
        "Cube.006",
        "Cube.010",
        "Cube.011"
      ]
    }
  }
];

export const BLOCK_COUNTING_CONFIG = {
  sectionName: "Block Counting",
  totalQuestions: 302,
  timeLimit: 4.5, // 4.5 minutes for 30 questions (official), scaled for practice
  instructions: "Look at the stack of blocks. One block is highlighted. Your task is to determine how many other blocks are touching the highlighted block. Blocks are touching if they share at least one face."
};

export default blockCountingData;
